import React, { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { motion } from 'framer-motion'
import { useEase } from './motion'

export const Slide = (props) => {

   const [slideRef, inView] = useInView({
      triggerOnce: false,
      threshold: props.threshold ? props.threshold : 0.2,
   })

   useEffect(() => {
      const soloSlide = [...document.querySelectorAll('.layout-slide')].length
      if (soloSlide === 1) {
         document.querySelector('.layout-slide').classList.add("solo-slide")
      }
      const lastOfClass = [...document.querySelectorAll('.layout-slide')].pop()
      lastOfClass.classList.add("last-slide")
   })

   const theme = props.theme? props.theme : 'default'
   const layout = props.layout? props.layout : 'single'
   const direction = props.direction? props.direction : 'normal'
   const classes = `layout-slide layout-slide-${layout} direction-${direction} theme-${theme}`

   const children = React.Children.map(props.children, (child, index) => {
		return React.cloneElement(child, {
				index,
				staggerIndex: index,
				slideVisible: inView
		});
	});

   return (
      <section className={classes} ref={slideRef}>
         {children}
      </section>
   )

}

export const ContentContainer = (props) => {

   const id = props.id ? props.id : ''
   const classes = `content-container ${id}`
   // const fadeUp = {
   //    hidden: {
   //       opacity: 0.8,
   //       y: 300,
   //       transition: {
   //          ease: [0.25, 1, 0.5, 1],
   //          duration: 0.1,
   //          delay: 0.5,
   //       },
   //    },
   //    show: {
   //       opacity: 1,
   //       y: 0,
   //       transition: {
   //          ease: [0.25, 1, 0.5, 1],
   //          delay: 0.5,
   //          duration: 1,
   //       }
   //    }
   // }
   // const fade = {
   //    hidden: {
   //       opacity: 0,
   //       transition: {
   //          ease: [0.25, 1, 0.5, 1],
   //          duration: 0.5,
   //       },
   //    },
   //    show: {
   //       opacity: 1,
   //       transition: {
   //          ease: [0.25, 1, 0.5, 1],
   //          delay: 0.25,
   //          duration: 1,
   //       }
   //    }
   // }

   // const animation = (transition) => {
   //    if ( transition === 'fadeUp' ) {
   //       return fadeUp;
   //    }
   //    if ( transition === 'fade' ) {
   //       return fade;
   //    }
   // }

   return (
      <motion.div
         className={classes}
         // variants={animation(props.transition)}
         // initial='hidden'
         // animate={props.slideVisible? 'show' : 'hidden'}
      >
         {props.children}
      </motion.div>
   )

}

export const Paragraph = (props) => {
   // const [paragraphRef, inView] = useInView({
	// 	triggerOnce: true,
	// 	threshold: 0.7,
   // })

   // function customSwitchX(direction) {
   //    switch (direction) {
   //       case 'left':
   //          return '-20vw'
   //          break;

   //       case 'right':
   //          return '20vw'
   //          break;

   //       default:
   //          0
   //          break;
   //    }
   // }

   // function customSwitchY(direction) {
	// 	switch (direction) {
	// 		case "down":
	// 			return "10vh"
	// 			break

	// 		default:
	// 			0
	// 			break
	// 	}
   // }

   // const textVar = {
   //    hidden: custom => ({
   //       x: customSwitchX(custom),
   //       y: customSwitchY(custom),
   //       opacity: 0,
   //    }),
   //    show: {
   //       x: 0,
   //       y: 0,
   //       opacity: 1,
   //       transition: {
   //          ease: useEase('easeOutExpo'),
   //          duration: 1.3,
   //       }
   //    }
   // }

   const direction = props.direction ? props.direction : 'static'
   const id = props.id ? props.id : ''
   const paragraphClasses = `textAnime direction-${direction} ${id}`

   return (
		<motion.div
			className={paragraphClasses}
			// variants={textVar}
			// custom={props.direction}
			// initial="hidden"
			// animate={inView ? "show" : "hidden"}
			// ref={paragraphRef}
		>
			{props.children}
		</motion.div>
   )
}